import React, { useState, useEffect } from "react";
import { List, Button } from "antd";
import BrandColors from "@brand-colors";
import { useTranslation } from "react-i18next";
const PendingSurveyList = (props: {
  surveyList: Array<[]>;
  onSelectSurvey: (surveyMeta: any) => void;
}) => {
  const [selectedSurvey, setSelectedSurvey] = useState();
  const { t } = useTranslation();
  const ActivityStatusEnum: any = {
    0: "None",
    120000000: t("AUTH2FA.OPEN"),
    120000001: t("AUTH2FA.COMPLETED"),
    120000002: "Skipped",
  };
  const styles = {
    list: {
      alignItems: "left",
    },
    list_item: {
      textAlign: "left",
      "&:hover": {
        backgroundColor: "blue",
        color: "white",
        "& .MuiListItemIcon-root": {
          color: "white",
        },
      },
    },
    list_item_button: {
      textAlign: "left",
    },
  };
  const hashText = (text: string) => {
    if (text?.length < 5) return text;

    let shown = text?.slice(0, 5);
    let masked = "*".repeat(text?.length - 5);
    return shown + masked;
  };
  const sortedSurveyList = [...props.surveyList].sort((a, b) => {
    return a.MemberName.localeCompare(b.MemberName);
  });

  console.log("abc", sortedSurveyList);

  const SurveyItem = (props: { data: any }) => {
    let actStat = props.data.ActivityStatus;
    return (
      <List.Item
        key={props.data.Urn}
        style={styles.list_item}
        data-testid="pending-survey-btn"
      >
        <Button
          type={
            selectedSurvey && selectedSurvey["Urn"] === props.data.Urn
              ? "primary"
              : "default"
          }
          disabled={props.data.ActivityStatus === 120000000 ? false : true}
          ghost={
            selectedSurvey && selectedSurvey["Urn"] === props.data.Urn
              ? true
              : false
          }
          block
          style={styles.list_item_button}
          onClick={() => setSelectedSurvey(props.data)}
        >
          <p
            style={{
              color: BrandColors.BRAND_PRIMARY,
              textAlign: "left",
              margin: 0,
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {hashText(props.data.MemberName)}{" "}
            <span style={{ float: "right", color: "#8c8c8c" }}>
              {ActivityStatusEnum[actStat]}
            </span>
          </p>
        </Button>
      </List.Item>
    );
  };
  useEffect(() => {
    console.log(selectedSurvey);
    if (selectedSurvey) props.onSelectSurvey(selectedSurvey);
  }, [selectedSurvey]);

  if (!sortedSurveyList?.length) {
    return null;
  }
  return (
    <>
      <List
        size="small"
        itemLayout="horizontal"
        dataSource={sortedSurveyList}
        renderItem={(item) => <SurveyItem data={item} />}
      />
    </>
  );
};

export default PendingSurveyList;
